<template>
    <v-container style="padding: 0 !important;" fluid>
        <p class="mb-3">{{ $t('shareJournalPeople') }}</p>
        <v-row>
            <v-col cols="2" class="pl-0">
              <v-card @click="createSharedLink" class="adding-card-collapsed d-flex align-center justify-center" elevation="0">
                <div class="d-flex justify-center align-center px-3 justify-center">
                  <v-icon class="plus-icon">fa-share</v-icon>
                  <p>{{ $t('shareLink') }}</p>
                </div>
              </v-card>
            </v-col> 
            <!--v-col cols="2">
                <v-card @click="findUser" class="adding-card d-flex align-center justify-center" elevation="0">
                    <div class="d-flex justify-center">
                        <v-icon class="plus-icon">fa-search</v-icon>
                        <h3 style="font-size: 17px" class="ml-2 mt-3">Find Friend</h3>
                    </div>
                </v-card>
            </v-col>
            <v-col cols="2" :key="share.id" v-for="share in byMeRequests">
                <v-card @click="openShare(share)" class="overall-card" outlined>
                    <v-card-text class="pa-5 d-flex align-center">
                        <div>
                            <v-avatar size="42">
                              <v-img :src="share.toUser.imageUrl !== null? share.toUser.imageUrl : 'https://upload.wikimedia.org/wikipedia/commons/d/d3/User_Circle.png'" contain></v-img>
                            </v-avatar>
                            <v-chip class="ml-2" small :color="getColorByStatus(share.shareStatus)" :text-color="textColorByStatus(share.shareStatus)"> {{ capitalize(share.shareStatus) }}</v-chip>
                            <h3 class="head mt-5">{{ share.toUser.firstName }}</h3>
                            <p class="content">{{ truncateString(share.toUser.login) }}</p>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col!-->
        </v-row>

        <!--v-divider class="my-5"/>

        <h3 v-if="this.$store.state.user.details.profileStatus === 'PRIVATE'" class="mt-5">People I shared my Journal with</h3>
        <v-row v-if="this.$store.state.user.details.profileStatus === 'PRIVATE'">
            <v-col cols="2">
                <v-card @click="createSharedLink" class="adding-card d-flex align-center justify-center" elevation="0">
                    <div class="d-flex justify-center">
                        <v-icon class="plus-icon">fa-share</v-icon>
                        <h3 style="font-size: 17px" class="ml-2 mt-3">Share Link</h3>
                    </div>
                </v-card>
            </v-col>
            <v-col cols="2" :key="share.id" v-for="share in byOthersRequests">
                <v-card @click="viewShareRequest(share)" :class="(share.shareStatus === 'REQUESTED')? 'new-request-card' : 'overall-card'" outlined>
                    <v-card-text class="pa-5 d-flex align-center">
                        <div>
                            <v-avatar size="42">
                              <v-img :src="share.requestedBy.imageUrl !== null? share.requestedBy.imageUrl : 'https://upload.wikimedia.org/wikipedia/commons/d/d3/User_Circle.png'" contain></v-img>
                            </v-avatar>
                            <v-chip class="ml-2" small :color="getColorByStatus(share.shareStatus)" :text-color="textColorByStatus(share.shareStatus)"> {{ capitalize(share.shareStatus) }}</v-chip>
                            <h3 class="head mt-5">{{ share.requestedBy.firstName }}</h3>
                            <p class="content">{{ truncateString(share.requestedBy.login) }}</p>
                        </div>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row!-->

        <v-overlay :dark="false" :value="overlayFindUser">
            <FindUser @closeWindow="overlayFindUser = false" @shareRequestCreated="shareRequestCreated"/>
        </v-overlay>
        <v-overlay :dark="false" :value="overlayShareDetails">
            <ShareRequestDetails :sharing-details="sharingDetails" @closeWindow="overlayShareDetails = false"/>
        </v-overlay>
        <v-overlay :dark="false" :value="overlayShareLink">
            <ShareLink @closeWindow="overlayShareLink = false"/>
        </v-overlay>
    </v-container>
</template>

<script>
    import Repository from '../../repositories/sharing';
    import FindUser from "./components/FindUser";
    import ShareLink from "./components/ShareLink";
    import ShareRequestDetails from "./components/ShareRequestDetails";
    import { mapMutations } from 'vuex';
    export default {
        name: "SharingModule",
        components: {ShareRequestDetails, ShareLink, FindUser},
        data() {
            return {
                byMeRequests: [],
                byOthersRequests: [],
                sharingDetails: null,

                // Overlays
                overlayFindUser: false,
                overlayShareDetails: false,
                overlayShareLink: false,
                overlayFindClub: false,
            };
        },
        mounted() {
            //this.init();
        },
        methods: {
            init() {
                Repository.requestedByMeRequests().then((response) => {
                    if(response.status < 400) {
                        this.byMeRequests = response.data;
                    }
                });

                Repository.requestedByOthersRequests().then((response) => {
                    if(response.status < 400) {
                        this.byOthersRequests = response.data;
                    }
                });
            },
            findUser() {
                this.overlayFindUser = true;
            },
            createSharedLink() {
                this.overlayShareLink = true;
            },
            ...mapMutations(['setShare']),
            openShare(share) {
                if(share.shareStatus === 'APPROVED') {
                    let sharingDetails = {
                        id: share.toUser.id,
                        username: share.toUser.login,
                        imageUrl: share.toUser.imageUrl,
                        firstName: share.toUser.firstName,
                        lastName: share.toUser.lastName,
                        country: '',
                        allowComments: share.allowComments,
                    };
                    this.setShare(sharingDetails);
                    this.$router.push('/book/shared');
                }
                else if(share.shareStatus === 'REQUESTED')
                    alert(this.$t('requestNoApproved'));
                else
                    alert(this.$t('requestDenied'));
            },
            shareOptions(share) {
                // eslint-disable-next-line no-console
                console.log(share);
            },
            viewShareRequest(share) {
                this.sharingDetails = share;
                this.overlayShareDetails = true;
            },
            shareRequestCreated(shareRequest) {
                this.byMeRequests.push(shareRequest);
                this.overlayFindUser = false;
            },
            capitalize(string) {
                return string[0] + string.slice(1).toLowerCase();
            },
            truncateString(string) {
                return (string !== null && string.length > 70)? `${string.substring(0, 70)}...`: string;
            },
            getColorByStatus(status) {
                switch (status) {
                    case 'APPROVED':
                        return 'var(--v-darkGreen-base)';
                    case 'DENIED':
                        return '#6C7079';
                    case 'REQUESTED':
                        return '#FFF75F';
                    default:
                        return '#FFF75F';
                }
            },
            textColorByStatus(status) {
                switch (status) {
                    case 'APPROVED':
                        return '#FFFFFF';
                    case 'DENIED':
                        return '#FFFFFF';
                    case 'REQUESTED':
                        return '#6C7079';
                    default:
                        return '#111111';
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "src/global";

    .new-request-card {
        height: 180px !important;
        min-width: 200px !important;
        border-radius: 20px !important;
        border: 2px solid #67707b !important;

        .head {
            color: $black-color !important;
            font-size: 28px !important;
        }

        .content {
            color: $text-color !important;
        }
    }
</style>



